<template>
	<div class="desktop-config refurbished-overlay">
		<div class="overview-overlay" style="display: block;">
			<div v-if="processingCheckout" class="refurbished-checkout">
				<p>Processing Checkout</p>
			</div>
			<div v-if="!processingCheckout" class="container-fluid p-x-lg">
				<div class="scroll-close">
					<div class="scroll-bounce">
						<template v-if="showScrollMessage">
							<h3 class="text-green text-upper">Scroll Down to see SPECS</h3>
							<i class="fa fa-chevron-down text-green arrow-bounce"/>
						</template>
					</div>
					<a
						class="close-overlay"
						href="javascript:void(0)"
						rel="overview-overlay"
						@click="closed()"
					>
						<img src="/assets/close-overlay.png" alt="Close overlay">
					</a>
				</div>
				<div class="row specs" :style="shouldShowBar && 'border-bottom: 4px solid #640a92'">
					<div class="col-md-3 col-xs-12">
						<div class="row final-review" style="display: block;">
							<div class="col-md-12">
								<h2 class="text-left">FINAL REVIEW</h2>
							</div>
						</div>
						<games-info-overlay :games="games" />
						<div v-if="build.gpus && build.gpus.vr_capable == '1'" class="vr-ready m-b-md" style="display: block;">
							<div class="text text-white">
								<h4>VR READY</h4>
								<p>
									This means your PC meets the minimum recommended specs to play VR games on the Oculus and HTC Vive.
								</p>
							</div>
						</div>
						<div class="text-white screen-resolution-text m-a-0">
							<p>{{ resolution }}</p>
						</div>
					</div>
					<div v-if="build.cases" class="col-md-4 col-xs-12">
						<div class="part-item part-item-1">
							<div class="row case-part">
								<div class="col-md-7 text-left">
									<div class="part-name">CASE:</div>
									<div class="part-label">
										<p>
											{{ build.cases.title }}
											<template v-if="!(+build.cases.is_limited) && build.cases.colors && build.cases.colors.join('').length">
												({{ build.cases.colors.join('/') }})
											</template>
										</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<div class="msrp">MSRP</div>
									<p>{{ build.cases.price | formatMoney }}</p>
								</div>
								<promo-sales-timed
									v-else-if="isRefurbishedBuild"
									class="col-md-5 text-right discount-price"
								>
									<template>
										<p v-if="casePromo(build.cases)">
											Gifted
										</p>
										<p v-else>
											<template v-if="promoDiscount(build.cases.price) > 0">
												{{ promoDiscount(build.cases.price) }}
											</template>
											<template v-else>
												$0.00
											</template>
											<span class="text-line-through">{{ build.cases.price | formatMoney }}</span>
										</p>
										<!-- <promo-savings-msg
											v-if="currentPhase == 1"
											:phase="currentPhase"
											text="refurbished_builds_overview"
											:price="price"
										/>
										<promo-savings-msg
											v-else-if="
												currentPhase == 2 &&
													!Number.isNaN(Number(price)) &&
													Number(price) >= 1000
											"
											:phase="currentPhase"
											text="refurbished_builds_overview"
										/> -->
									</template>
								</promo-sales-timed>
							</div>
						</div>
						<div v-if="build.psus" class="part-item part-item-2">
							<div class="row">
								<div class="col-md-8 text-left">
									<div class="part-name">POWER:</div>
									<div class="part-label">
										<p>{{ build.psus.title }}</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<div class="msrp">MSRP</div>
									<p>{{ build.psus.price | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.gpus" class="part-item part-item-3">
							<div class="row">
								<div class="col-md-8 text-left">
									<div class="part-name">GPU:</div>
									<div class="part-label">
										<p>
											{{ build.gpus.title }}
											<template v-if="build.gpus.colors && build.gpus.colors.join('').length">
												({{ build.gpus.colors.join('/') }})
											</template>
											<template v-if="build.gpus.quantity > 1">
												({{ build.gpus.quantity }})
											</template>
										</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<div class="msrp">MSRP</div>
									<p>{{ build.gpus.price * build.gpus.quantity | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.cpus" class="part-item part-item-4">
							<div class="row">
								<div class="col-md-8 text-left">
									<div class="part-name">CPU:</div>
									<div class="part-label">
										<p>{{ build.cpus.title }}</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<div class="msrp">MSRP</div>
									<p>{{ build.cpus.price | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.motherboards" class="part-item part-item-5">
							<div class="row">
								<div class="col-md-8 text-left">
									<div class="part-name">MOTHERBOARD:</div>
									<div class="part-label">
										<p>
											{{ build.motherboards.title }}
											<template v-if="build.motherboards.colors && build.motherboards.colors.join('').length">
												({{ build.motherboards.colors.join('/') }})
											</template>
										</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<div class="msrp">MSRP</div>
									<p>{{ build.motherboards.price | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.ram" class="part-item part-item-6">
							<div class="row">
								<div class="col-md-8 text-left">
									<div class="part-name">RAM:</div>
									<div class="part-label">
										<p>
											{{ build.ram.name }}
											<small>(max speed)</small>
											<span v-html="computeRamCapacity(build.ram.capacity, build.ram.slots, build.ram.quantity)" />
										</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<div class="msrp">MSRP</div>
									<p>{{ build.ram.price * build.ram.quantity | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.storage && build.storage.SSD" class="part-item part-item-7">
							<div class="clearfix">
								<div class="part-name pull-left">SSD:</div>
								<div v-if="!isRefurbishedBuild" class="msrp text-white pull-right">MSRP</div>
							</div>
							<div v-for="disk in build.storage.SSD" :key="'overlay-ssd-' + disk.id" class="row clearfix">
								<div class="col-md-8 text-left">
									<div class="part-label">
										<p>
											{{ disk.title }} {{ disk.capacity }}
											<template v-if="disk.quantity > 1">
												({{ disk.quantity }})
											</template>
										</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<p>{{ disk.price * disk.quantity | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.storage && build.storage.HDD" class="part-item part-item-8">
							<div class="clearfix">
								<div class="part-name pull-left">HDD:</div>
								<div v-if="!isRefurbishedBuild" class="msrp text-white pull-right">MSRP</div>
							</div>
							<div v-for="disk in build.storage.HDD" :key="'overlay-hdd-' + disk.id" class="row clearfix">
								<div class="col-md-8 text-left">
									<div class="part-label">
										<p>
											{{ disk.title }} {{ disk.capacity }}
											<template v-if="disk.quantity > 1">
												({{ disk.quantity }})
											</template>
										</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<p>{{ disk.price * disk.quantity | formatMoney }}</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-5 col-xs-12">
						<div v-if="build.coolers" class="part-item part-item-cpu-cooling">
							<div class="row">
								<div class="col-md-8 text-left">
									<div class="part-name">CPU COOLING:</div>
									<div class="part-label">
										<p>{{ build.coolers.title }}</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<div class="msrp">MSRP</div>
									<p>{{ build.coolers.price | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.fans" class="part-item part-item-fans">
							<div class="clearfix">
								<div class="part-name pull-left">FANS:</div>
								<div v-if="!isRefurbishedBuild" class="msrp text-white pull-right">MSRP</div>
							</div>
							<div v-for="fan in build.fans" :key="'overlay-fan-' + fan.id" class="row clearfix">
								<div class="col-md-8 text-left">
									<div class="part-label">
										<p>
											{{ fan.title }}
											<template v-if="fan.colors && fan.colors.join('').length">
												({{ fan.colors.join('/') }})
											</template>
											<template v-if="fan.quantity > 1">
												({{ fan.quantity }})
											</template>
										</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<p>{{ fan.price * fan.quantity | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.rgbs" class="part-item part-item-rgbs">
							<div class="clearfix">
								<div class="part-name pull-left">RGBs:</div>
								<div v-if="!isRefurbishedBuild" class="msrp text-white pull-right">MSRP</div>
							</div>
							<div v-for="rgb in build.rgbs" :key="'overlay-rgb-' + rgb.id" class="row clearfix">
								<div class="col-md-8 text-left">
									<div class="part-label">
										<p>
											{{ rgb.title }}
											<template v-if="rgb.colors && rgb.colors.join('').length">
												({{ rgb.colors.join('/') }})
											</template>
											<template v-if="rgb.quantity > 1">
												({{ rgb.quantity }})
											</template>
										</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<p>{{ rgb.price * rgb.quantity | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.extras" class="part-item part-item-extra">
							<div class="clearfix">
								<div class="part-name pull-left">ACCESSORIES:</div>
								<div v-if="!isRefurbishedBuild" class="msrp text-white pull-right">MSRP</div>
							</div>
							<div v-for="extra in build.extras" :key="'overlay-accessory-' + extra.id" class="row clearfix">
								<div class="col-md-8 text-left">
									<div class="part-label">
										<p>
											{{ extra.title }}
											<template v-if="extra.colors && extra.colors.join('').length">
												({{ extra.colors.join('/') }})
											</template>
											<template v-if="extra.quantity > 1">
												({{ extra.quantity }})
											</template>
										</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<p>{{ extra.price * extra.quantity | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.streamingBundle" class="part-item part-item-streaming">
							<div class="clearfix">
								<div class="part-name pull-left">STREAMING:</div>
								<div v-if="!isRefurbishedBuild" class="msrp text-white pull-right">MSRP</div>
							</div>
							<div v-for="bundle in build.streamingBundle" :key="'overlay-streaming-' + bundle.id" class="row clearfix">
								<div class="col-md-8 text-left">
									<div class="part-label">
										<p>
											{{ bundle.title }}
											<template v-if="bundle.colors && bundle.colors.join('').length">
												({{ bundle.colors.join('/') }})
											</template>
											<template v-if="bundle.quantity > 1">
												({{ bundle.quantity }})
											</template>
										</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<p>{{ bundle.price * bundle.quantity | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.peripherals" class="part-item part-item-peripheral">
							<div class="clearfix">
								<div class="part-name pull-left">PERIPHERALS:</div>
								<div v-if="!isRefurbishedBuild" class="msrp text-white pull-right">MSRP</div>
							</div>
							<div v-for="peripheral in build.peripherals" :key="'overlay-peripheral-' + peripheral.id" class="row clearfix">
								<div class="col-md-8 text-left">
									<div class="part-label">
										<p>
											{{ peripheral.title }}
											<template v-if="peripheral.colors && peripheral.colors.join('').length">
												({{ peripheral.colors.join('/') }})
											</template>
											<template v-if="peripheral.quantity > 1">
												({{ peripheral.quantity }})
											</template>
										</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<p>{{ peripheral.price * peripheral.quantity | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.monitors" class="part-item part-item-monitors">
							<div class="clearfix">
								<div class="part-name pull-left">MONITORS:</div>
								<div v-if="!isRefurbishedBuild" class="msrp text-white pull-right">MSRP</div>
							</div>
							<div v-for="monitor in build.monitors" :key="'overlay-monitors-' + monitor.id" class="row clearfix">
								<div class="col-md-8 text-left">
									<div class="part-label">
										<p>
											{{ monitor.title }}
											<template v-if="monitor.colors && monitor.colors.join('').length">
												({{ monitor.colors.join('/') }})
											</template>
											<template v-if="monitor.quantity > 1">
												({{ monitor.quantity }})
											</template>
										</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<p>{{ monitor.price * monitor.quantity | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div v-if="build.softwares" class="part-item part-item-cpu-cooling">
							<div class="row">
								<div class="col-md-8 text-left">
									<div class="part-name">SOFTWARES:</div>
									<div class="part-label">
										<p>{{ build.softwares.title }}</p>
									</div>
								</div>
								<div v-if="!isRefurbishedBuild" class="col-md-4 part-price text-right">
									<div class="msrp">MSRP</div>
									<p>{{ build.softwares.price | formatMoney }}</p>
								</div>
							</div>
						</div>
						<div class="part-item part-item-add">
							<div class="row" v-if="build.services">
								<div class="col-md-8  text-left">
									<div class="part-name">SERVICE:</div>
									<div class="part-label">
										<p class="shipping_service_description">BLD Assembly &amp; Service Package ({{ build.services.title }}) </p>
										<ul>
											<li>2 years warranty on all parts &amp; labor</li>
											<promo-sales-timed>
												<template slot-scope="{ phasesInfo: { currentPhase } }">
													<li v-if="currentPhase != 1">Ships in 48 hours</li>
												</template>
											</promo-sales-timed>

											<li>Guaranteed Game performance</li>
											<li>Professional Wire Management</li>
										</ul>
									</div>
								</div>
								<div class="col-md-4 part-price text-right">
									<div :class="{'text-line-through': isRefurbishedBuild}" class="msrp">{{ build.services.price | formatMoney }}</div>
								</div>
							</div>
							<div class="compatibility">
								<div class="text text-white">
									<h4>COMPATIBILITY</h4>
								</div>
								<div class="row m-t">
									<div class="col-md-12 text-left">
										<compatibility-icons
											:build="build"
											class="refurbished-compatibility-icons "
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<div id="shipping-standard" class="col-md-12 estimated">Estimated shipping date {{ shippingDate }}</div>
							</div>
						</div>
						<div class="msrp-note">
							<div class="row">
								<div class="col-md-12">
									* We researched retailers and manufacturers for the MSRP so we can provide you with the fairest pricing we can.
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row price-check check-final">
					<div class="check-price-cant">
						<div class="price-cant overview-buy">
							<h3 class="price text-white">
								<promo-sales-timed>
									<template v-slot:originalContent>
										{{ price | formatMoney }}
									</template>
									<template>
										{{ promoDiscount(price) | formatMoney }}
									</template>
								</promo-sales-timed>
							</h3>
						</div>
						<promo-sales-timed>
							<template slot-scope="{ phasesInfo: { currentPhase } }">
								<div>
									<holiday-saving-msg
										v-if="casePromo(build.cases)"
										:phase="currentPhase"
										text="refurbishedOverviewCase"
									/>
									<holiday-saving-msg
										v-else
										:phase="currentPhase"
										text="refurbishedOverviewNonCase"
									/>
								</div>
							</template>
						</promo-sales-timed>
						<div class="checkout-btn">
							<a :disabled="processingCheckout" class="purchase btn btn-block btn-orchid" @click="processCheckout()">CHECKOUT</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { computeRamCapacity } from "@u/store-helpers";
import { promoDiscount, casePromo } from "@u/helpers";
import { heapAnalytics } from "@u/mixins.js";
import ShopifyClient from "shopify-buy";
import CompatibilityIcons from "./compatibility-icons.vue";
import GamesInfoOverlay from "./games-info-overlay.vue";
import { gtmTrack } from "@/util/gtm";
import HolidaySavingMsg from "@c/generals/holiday-saving-msg";
import PromoSalesTimed from "@/components/promo-sales-timed";

export default {
	name: "Overlay",
	components: {
		CompatibilityIcons,
		GamesInfoOverlay,
		HolidaySavingMsg,
		PromoSalesTimed
	},
	mixins: [
		heapAnalytics
	],
	props: {
		build: {
			type: Object,
			required: true
		},
		checkoutData: {
			type: Object,
			default: null
		},
		games: {
			type: [Array, Object],
			required: true
		},
		isRefurbishedBuild: {
			type: Boolean,
			default: false
		},
		price: {
			type: [Number, String],
			required: true
		},
		resolution: {
			type: [Number, String],
			required: true
		},
		showProcessing: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			processingCheckout: this.showProcessing,
			shippingDate: "",
			shouldShowBar: false,
			showScrollMessage: false
		};
	},
	created() {
		this.setBodyOverflow();
		this.getShippingDate();
	},
	mounted() {
		if (!this.shouldShowBar) {
			$(".row.specs").on("scroll", () => {
				this.shouldShowBar = true;
				$(".row.specs").off("scroll");
			});
		}

		this.$nextTick(() => {
			this.showScrollMessage = $(".row.specs").hasScrollBar();
		});
	},
	beforeDestroy() {
		document.querySelector("body").classList.remove("refurbished-body");
	},
	methods: {
		computeRamCapacity,
		promoDiscount,
		casePromo,
		closed() {
			document.querySelector("body").classList.remove("refurbished-body");
			this.$emit("closed");
		},
		getDeviceType() {
			return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
				.test(navigator.userAgent) ? "mobile" : "desktop";
		},
		getShippingDate() {
			const { id } = this.build.services || {};
			axios({
				url: `/shipping-date/${id}`
			}).then((response) => {
				this.shippingDate = response.data.date;
			});
		},
		processCheckout() {
			this.processingCheckout = true;
			this.trackAll("Client: Refurbished Checkout");

			const data = {
				resolution: this.resolution
			};

			if (this.games.length) {
				const games = this.games.map(game => {
					return {
						id: game.id,
						fps: parseInt(game.fps)
					};
				});

				data.games = JSON.stringify(games);
			}

			axios({
				url: `/checkout-refurbished-fast/${this.checkoutData.bldNumber}`,
				params: data,
				headers: {
					token: CONFIG.SESSION
				}
			}).then(async(response) => {
				let shopifyCheckout = null;
				const customAttributes = [
					{
						key: "bld_number",
						value: response.data.bld_number
					},
					{
						key: "source_device",
						value: this.getDeviceType()
					},
					{
						key: "heap_uuid",
						value: localStorage.getItem("heap-uuid")
					},
					{
						key: "checkout",
						value: "refurbished"
					},
					{
						key: "preBuild",
						value: "0"
					}
				];

				const shopifyClient = await ShopifyClient.buildClient({
					domain: process.env.MIX_SHOPIFY_DOMAIN,
					storefrontAccessToken: process.env.MIX_SHOPIFY_SDK_KEY
				});
				let currencyCode = {};

				if (this.$store.state.User.location.country_code == "CA") {
					currencyCode = { presentmentCurrencyCode: "CAD" };
				}

				await shopifyClient.checkout.create({ customAttributes, ...currencyCode }).then(checkout => {
					shopifyCheckout = checkout;
				});

				shopifyClient.checkout.addLineItems(
					shopifyCheckout.id,
					response.data.checkout_list
				).then(({ totalPrice }) => {
					gtmTrack.cartTotal(parseFloat(totalPrice || 0));
					gtmTrack.cartPrebuild();
					location.href = shopifyCheckout.webUrl;
				}).catch(() => {
					this.processingCheckout = false;
				});
			}).catch(() => {
				this.processingCheckout = false;
			});
		},
		setBodyOverflow() {
			document.querySelector("body").classList.add("refurbished-body");
		}
	}
};
</script>


<style lang="scss">
@media (max-width: 767px) {
		.refurbished-body {
				overflow: hidden;
		}
}

.check-price-cant {
	text-align: inherit;
	margin-bottom: 15px;

	p {
		font-size: 14px;
	}
}
</style>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.highlight {
		color: $orchid;
}

.refurbished-compatibility-icons {
		bottom: 0px;
		right: 0px;
}

.text-line-through {
		text-decoration: line-through;
}

.price-check {
		@media (max-width: 767px) {
				justify-content: flex-start !important;
				padding-left: 30px;
		}
}

.refurbished-overlay .overview-overlay {
		background-color: rgba(17, 17, 17, 0.9);
		top: 0;
		position: fixed;
		z-index: 2;
		display: flex !important;
		align-items: flex-start;
		max-height: initial;
		padding-top: 100px;

		.container-fluid {
				overflow-y: auto;
		}
}

.refurbished-checkout {
		align-items: center;
		display: flex;
		height: calc(100vh - 150px);
		justify-content: center;
		width: 100%;

		p {
				background-image: url("/assets/spinner-white.svg");
				background-position: -13px center;
				background-repeat: no-repeat;
				background-size: 20%;
				color: white;
				display: flex;
				font-size: 24px;
				letter-spacing: 2px;
				line-height: 40px;
				padding-left: 54px;
				text-transform: uppercase;
		}

		p::after {
				animation: loadingdots 1s infinite ease-in-out;
				content: "";
				width: 20px;
		}
}

.nzxtcustom .desktop-config .row.specs {
		max-height: 578px;
		@media screen and (max-width: 1440px) and (min-width: 320px) {
				max-height: 450px;
		}
}

.row.price-check .btn.purchase {
		max-width: 300px;
}

.purchase {
		background-color: $orchid;
		border-color: $orchid;
}

.check-price-cant {
		display: flex;
		align-items: flex-end;
		text-align: right;

		@media (min-width: 767px) and (max-width: 991px) {
				margin-right: 30px;
		}

		@media (max-width: 767px) {
				align-items: flex-start;
				text-align: left;
		}
}

@media (max-width: 360px) {
		.nzxtcustom {
				.desktop-config {
						.row {
								&.price-check {
										.check-price-cant {
												.btn.purchase {
														max-width: 135px;
														padding: 16px 28px;
												}
										}
								}
						}
				}
		}
}

.nzxtcustom {
		.desktop-config {
				.row {
						&.price-check {
								.check-price-cant {
										flex-direction: column;
								}

								.btn.purchase {
										padding: 16px 40px;
								}
						}
				}
		}
}

@media (max-width: 768px) {
		.refurbished-overlay .overview-overlay {
				.container-fluid {
						padding: 0 !important;

						.close-overlay {
								margin-right: 20px;
						}
				}
		}
}
@media (max-width: 411px) {
		.refurbished-checkout {
				p {
						background-position: left center;
						background-size: 46px;
						font-size: 14px;
						padding-left: 42px;
				}
		}
		.nzxtcustom {
				.desktop-config {
						.row {
								&.specs {
										max-height: 450px;
								}

								&.price-check {
										justify-content: space-between;
										align-items: center;

										.btn {
												&.purchase {
														padding: 16px 35px;
														border-radius: 0;
														margin-right: 0;
														max-width: 157px;
												}
										}
								}
						}
				}
		}
}

.refurbished-overlay::v-deep {
		.holiday-savings-msg {
			font-family: "Akkurat-Normal", "Helvetica Neue", "Helvetica", Arial, sans-serif;

			p {
				text-align: left !important;
				margin-bottom: 10px;
				color: #ffffff !important;

				@media (min-width: 767px) {
					text-align: right !important;
				}
			}

			.highlight {
				color: $orchid !important;
			}

			br {
				@media (min-width: 768px) {
					display: none;
				}
			}
		}

		.discount-price {
			font-size: 18px !important;
			color: #cfcfcf !important;

			@media (max-width: 1023px) {
				margin-left: auto;
			}
		}
}

.refurbished-overlay .case-part {
	display: flex;
	align-items: flex-end;
}
</style>
